module.exports = __webpack_public_path__ + "static/img/background@2x.b0be91e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/KtbTrio_min/background@2x.png
// module id = MmTh
// module chunks = 70